<modal 
  #modal
  (onClose)="close()"
  [closeButtonText]="_appService.CoreCommonLiterals?.ButtonClose"
  [submitButtonText]="(status === 0 && !shareLink && dashboardId) || 
    (status === 0 && !shareLink && graphicalViewId) || 
    (status === 0 && !shareLink && assetsId) ?
    _gearAppService.GearMonitorLiterals?.ShareDashboardGetLink : null"
  (onSubmit)="dashboardId ? getLink() : graphicalViewId ? getLinkView() : assetsId ? getLinkAssets() : null"
>
  <modal-header *ngIf="_gearAppService.GearCommonLiterals">
    {{ (dashboardId ) ? _appService.CoreCommonLiterals?.ShareDashboard : 
    (graphicalViewId) ? _appService.CoreCommonLiterals?.ShareView : 
    (assetsId) ? _appService.CoreCommonLiterals?.ShareAssetsTraking : null }}
  </modal-header>
  <modal-content>
    <div *ngIf="status === 1" class="text-center">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
    </div>
    <div *ngIf="status === 0 && shareLink !== null">
      <label for="share-link">{{_gearAppService.GearMonitorLiterals?.ShareDashboardLink}}</label>
      <div class="input-group mb-3">
        <input type="text" id="share-link" class="form-control" readonly [value]="shareLink">
        <div class="input-group-append">
          <button 
            class="btn btn-primary" 
            type="button" 
            id="copy" 
            [tooltip]="_appService.CoreCommonLiterals?.Copy" 
            (click)="copyToClipboard(shareLink)"
          ><i class="fa fa-copy"></i></button>
        </div>
      </div>
    </div>
    <div *ngIf="status === 0 && !shareLink">
      <p *ngIf="dashboardId">{{_gearAppService.GearMonitorLiterals?.ShareDashboardInfo}}</p>
      <p *ngIf="dashboardId">{{_gearAppService.GearMonitorLiterals?.ShareDashboardLinksInfo}} 
        <a href="/gear/manager/master-tables/shared-links">
          {{_gearAppService.GearMonitorLiterals.ShareDashboardSeeLinksList}}
        </a>
      </p>
      <p *ngIf="graphicalViewId">{{_gearAppService.GearMonitorLiterals?.ShareViewInfo}}</p>
      <p *ngIf="assetsId">{{_gearAppService.GearMonitorLiterals?.ShareAssetsInfo}}</p>
      <div class="form-group" *ngIf="dashboardId">
        <label for="description">{{_appService.CoreCommonLiterals.Description}} ({{_appService.CoreCommonLiterals.Optional}})</label>
        <input
        type="text"
        customFocus
        name="description"
        [(ngModel)]="dashboardDescription"
        class="form-control"
        id="description"
        [placeholder]="_appService.CoreCommonLiterals.Description"
        >
      </div>
      <div class="custom-control custom-checkbox mb-2" *ngIf="dashboardId || graphicalViewId">
        <input
          type="checkbox"
          class="custom-control-input"
          id="availableMobileApp"
          name="availableMobileApp"
          [(ngModel)]="availableMobileApp">
        <label class="custom-control-label" for="availableMobileApp">{{_appService.CoreCommonLiterals.AvailableMobileApp}}</label>
        <span class="ml-2" triggers="click hover" [tooltip]="dashboardId ? _appService.CoreCommonLiterals.AvailableMobileAppTooltip : _appService.CoreCommonLiterals?.AvailableMobileAppViewTooltip"><i class="fa fa-question-circle"></i> </span>
      </div>
    </div>
    <div *ngIf="status === 2 && error" class="alert alert-danger">{{error}}</div>
  </modal-content>
</modal>